import { atom } from 'jotai';

/** `null` = pas encore chargé ; sinon `activeVersion.id` → texte (ou `null`). */
export const dealItemDescriptionsByActiveVersionIdState = atom<Record<
  string,
  string | null
> | null>(null);
